import { 
    GET_BARCODE_REPORT_ASSET_IMAGES,
    GET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES,
    GET_BARCODE_REPORT_EXCEL_DATA,
    GET_BARCODE_REPORT_GRID_DATA,
    GET_BARCODE_REPORT_MARKET_DROPDOWN,
    GET_BARCODE_REPORT_REGION_DROPDOWN,
    GET_BARCODE_REPORT_USER_DROPDOWN,
    SET_BARCODE_REPORT_ASSET_IMAGES,
    SET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    SET_BARCODE_REPORT_EXCEL_DATA,
    SET_BARCODE_REPORT_GRID_DATA,
    SET_BARCODE_REPORT_GRID_FILTERS,
    SET_BARCODE_REPORT_MARKET_DROPDOWN,
    SET_BARCODE_REPORT_REGION_DROPDOWN,
    SET_BARCODE_REPORT_USER_DROPDOWN
} from "./BarcodeReportType";

const getBarcodeReportGridData = (payload:any) => ({
    type: GET_BARCODE_REPORT_GRID_DATA,
    payload
});

const setBarcodeReportGridData = (gridData: any) => ({
    type: SET_BARCODE_REPORT_GRID_DATA,
    gridData
});

const getBarcodeReportExcelData = (payload: any) => ({
    type: GET_BARCODE_REPORT_EXCEL_DATA,
    payload
});

const setBarcodeReportExcelData = (excelData: any) => ({
    type: SET_BARCODE_REPORT_EXCEL_DATA,
    excelData
});

const getBarcodeReportUserDropdown = () => ({
    type: GET_BARCODE_REPORT_USER_DROPDOWN
});

const setBarcodeReportUserDropdown = (userDropdown: any) => ({
    type: SET_BARCODE_REPORT_USER_DROPDOWN,
    userDropdown
});

const getBarcodeReportRegionDropdown = () => ({
    type: GET_BARCODE_REPORT_REGION_DROPDOWN
});

const setBarcodeReportRegionDropdown = (regionDropdown: any) => ({
    type: SET_BARCODE_REPORT_REGION_DROPDOWN,
    regionDropdown
});

const getBarcodeReportMarketDropdown = () => ({
    type: GET_BARCODE_REPORT_MARKET_DROPDOWN
});

const setBarcodeReportMarketDropdown = (marketDropdown: any) => ({
    type: SET_BARCODE_REPORT_MARKET_DROPDOWN,
    marketDropdown
});

const getBarcodeReportCostCenterDropdown = () => ({
    type: GET_BARCODE_REPORT_COSTCENTER_DROPDOWN
});

const setBarcodeReportCostCenterDropdown = (costCenterDropdown: any) => ({
    type: SET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    costCenterDropdown
});

const setBarcodeReportGridFilters = (barcodeReportGridFilters: any) => ({
    type: SET_BARCODE_REPORT_GRID_FILTERS,
    barcodeReportGridFilters
});

const getBarcodeReportAssetImages = (payload: any) => ({
    type: GET_BARCODE_REPORT_ASSET_IMAGES,
    payload
});

const setBarcodeReportAssetImages = (assetImages: any) => ({
    type: SET_BARCODE_REPORT_ASSET_IMAGES,
    assetImages
});

const getBarcodeReportDashboardAssetImages = (payload: any) => ({
    type: GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES,
    payload
});

export {
    getBarcodeReportGridData,
    setBarcodeReportGridData,
    getBarcodeReportExcelData,
    setBarcodeReportExcelData,
    getBarcodeReportUserDropdown,
    setBarcodeReportUserDropdown,
    getBarcodeReportRegionDropdown,
    setBarcodeReportRegionDropdown,
    getBarcodeReportMarketDropdown,
    setBarcodeReportMarketDropdown,
    getBarcodeReportCostCenterDropdown,
    setBarcodeReportCostCenterDropdown,
    setBarcodeReportGridFilters,
    getBarcodeReportAssetImages,
    setBarcodeReportAssetImages,
    getBarcodeReportDashboardAssetImages
}
